import React from "react";
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	IconButton,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

function ReturnTicketList(props) {
	function handleDelete(id) {
		props.handleDeleteFunktion(id);
	}

	return (
		<>
			<TableContainer component={Paper}>
				<Table
					aria-label="summary of interrail passes in shopping cart"
					size="small"
				>
					<TableHead>
						<TableRow>
							<TableCell></TableCell>
							<TableCell>Areal (ha)</TableCell>
							<TableCell>Ålder</TableCell>
							<TableCell>SI</TableCell>
							<TableCell>Virkes förråd (m3sk)</TableCell>
							<TableCell>Mål klass</TableCell>
							<TableCell>Träd slag</TableCell>
							<TableCell>Med diam (cm)</TableCell>
							<TableCell>Med höjd (m)</TableCell>
							<TableCell>Stam antal</TableCell>
							<TableCell>G-yta</TableCell>
							<TableCell>Fukt</TableCell>
							<TableCell align="right"> </TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{props.bestånd.map((bestånd, index) => (
							<TableRow key={index}>
								<TableCell>{index + 1}</TableCell>
								<TableCell>{bestånd.areal}</TableCell>
								<TableCell>{bestånd.ålder}</TableCell>
								<TableCell>{bestånd.si}</TableCell>
								<TableCell>{bestånd.virkesförråd}</TableCell>
								<TableCell>{bestånd.målklass}</TableCell>
								<TableCell>
									{bestånd.trädslag.map(
										(object) => object.trädslag + object.procentsats
									)}
								</TableCell>
								<TableCell>{bestånd.diameter}</TableCell>
								<TableCell>{bestånd.trädhöjd}</TableCell>
								<TableCell>{bestånd.stamantal}</TableCell>
								<TableCell>{bestånd.grundyta}</TableCell>
								<TableCell>{bestånd.fuktighetsklass}</TableCell>
								<TableCell align="right">
									<IconButton
										aria-label="delete"
										onClick={() => handleDelete(bestånd.id)}
									>
										<ClearIcon />
									</IconButton>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</>
	);
}

export default ReturnTicketList;
